<div id="closeBtnNote">
  <span (click)="closeNote()">×</span>
</div>
<div id="bijiNote" *ngIf="showCourse" style="background-color:#F0F2FA;">
  <img class="changzouwen" *ngIf="course.name=='卓越辅导'" src="{{assetsRoute}}/picture/courselearning/jinghua1_new.png"/>
  <img class="changzouwen" *ngIf="course.name=='团队课程'" src="{{assetsRoute}}/picture/courselearning/jinghua2.png"/>
  <img class="changzouwen" *ngIf="course.name=='授权课程'" src="{{assetsRoute}}/picture/courselearning/jinghua3.png"/>
  <img class="changzouwen" *ngIf="course.name=='组织与计划课程'" src="{{assetsRoute}}/picture/courselearning/jinghua4_new.png"/>
  <img class="changzouwen" *ngIf="course.name=='沟通课程'" src="{{assetsRoute}}/picture/courselearning/jinghua5.png"/>
  <img class="changzouwen" *ngIf="course.name=='协作课程'" src="{{assetsRoute}}/picture/courselearning/jinghua6.png"/>
  <img class="changzouwen" *ngIf="course.name=='影响力课程'" src="{{assetsRoute}}/picture/courselearning/jinghua7.png"/>
  <img class="changzouwen" *ngIf="course.name=='影响力专业版课程'" src="{{assetsRoute}}/picture/courselearning/jinghua14.png"/>
  <img class="changzouwen" *ngIf="course.name=='决策课程'" src="{{assetsRoute}}/picture/courselearning/jinghua8.png"/>
  <img class="changzouwen" *ngIf="course.name=='驱动变革课程'" src="{{assetsRoute}}/picture/courselearning/jinghua9.png"/>
  <img class="changzouwen" *ngIf="course.name=='领导力启程'" src="{{assetsRoute}}/picture/courselearning/jinghua10.png"/>
  <div class="changzouwen hot" *ngIf="course.name=='达至最佳绩效课程'">
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-1.jpg" alt="" />
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-2.jpg" alt=""  (click)="openPDF(1)" />
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-3.jpg" alt="" />
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-4.jpg" alt=""  (click)="openPDF(2)" />
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-5.jpg" alt="" />
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-6.jpg" alt=""  (click)="openPDF(3)" />
    <img src="{{assetsRoute}}/picture/courselearning/jinghua11-7.jpg" alt="" />
  </div>
  <!--<img class="changzouwen" *ngIf="course.name=='达至最佳绩效课程'" src="{{assetsRoute}}/picture/courselearning/jinghua11.png"/>-->
  <img class="changzouwen" *ngIf="course.name=='目标选才课程'" src="{{assetsRoute}}/picture/courselearning/jinghua12.png"/>
  <img class="changzouwen" *ngIf="course.name=='解决冲突课程'" src="{{assetsRoute}}/picture/courselearning/jinghua13.png"/>
</div>



// WEBPACK FOOTER //
// ./src/app/course-learning-home/course-learning-home-note.component.html